import React, { useEffect } from "react";

export default function DarkModeToggle({ dark, setDark }) {
  useEffect(() => {
    document.body.style.background = dark ? "#222" : "#fafafa";
    document.body.style.color = dark ? "#eee" : "#222";
  }, [dark]);

  return (
    <div style={{ marginBottom: 16 }}>
      <label>
        <input
          type="checkbox"
          checked={dark}
          onChange={e => setDark(e.target.checked)}
        />
        Dark Mode
      </label>
    </div>
  );
}